import { useMutation, useQuery } from "@apollo/client";
import {
  meGQL,
  Query,
  updateUserMetadataGQL,
  User,
} from "@onmo/graphql/graphql";

const MAX_ITEMS = 10;

const updateRecentlyPlayed = (
  currentList: string[] | undefined,
  newGameId: string,
): string[] => {
  const list = currentList || [];
  const filteredList = list.filter((id) => id !== newGameId);
  const updatedList = [newGameId, ...filteredList];
  return updatedList.slice(0, MAX_ITEMS);
};

export const useUpdateRecentlyPlayed = () => {
  const { data: dataMe } = useQuery<{ me: Query["me"] }>(meGQL);
  let calculatedNewProducts: string[] = [];

  const [updateUserMetadata] = useMutation(updateUserMetadataGQL, {
    update: (cache, { data }) => {
      if (!data || !dataMe || calculatedNewProducts.length === 0) return;
      const existing = cache.readQuery<{ me: User }>({
        query: meGQL,
      });
      if (!existing?.me) return;
      cache.writeQuery({
        query: meGQL,
        data: {
          me: {
            ...dataMe,
            metadata: {
              ...dataMe?.me.metadata,
              __typename: existing.me.metadata?.__typename,
              tgpRecentlyPlayedItems: calculatedNewProducts,
            },
          },
        },
      });
      calculatedNewProducts = [];
    },
  });

  const updateProducts = (gameId: string) => {
    if (!dataMe || !dataMe?.me?.metadata) {
      return;
    }

    const currentProducts = dataMe?.me?.metadata
      .tgpRecentlyPlayedItems as string[];
    const newRecentlyPlayed = updateRecentlyPlayed(currentProducts, gameId);
    calculatedNewProducts = newRecentlyPlayed;

    try {
      updateUserMetadata({
        variables: {
          input: {
            tgpRecentlyPlayedItems: newRecentlyPlayed,
          },
        },
      });
    } catch (error) {
      console.error("Error updating recently played:", error);
      calculatedNewProducts = [];
    }
  };

  return { updateProducts };
};
